/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Happy_Loud_Crab_MeltInputs */

const en_happy_loud_crab_melt = /** @type {(inputs: Happy_Loud_Crab_MeltInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Email`)
};

const de_happy_loud_crab_melt = /** @type {(inputs: Happy_Loud_Crab_MeltInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`E-Mail-Adresse`)
};

/**
* | output |
* | --- |
* | "Email" |
*
* @param {Happy_Loud_Crab_MeltInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const happy_loud_crab_melt = /** @type {((inputs?: Happy_Loud_Crab_MeltInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Happy_Loud_Crab_MeltInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_happy_loud_crab_melt(inputs)
	return de_happy_loud_crab_melt(inputs)
});